import { ApiService, toModels } from '~/shared/api'
import { VacancyNewCardModel } from '~/models/vacancy'
import { API_PREFIX } from '~/shared/const/request-services'

export class VacancyService extends ApiService {
  readonly urls = {
    top: `${API_PREFIX}/vacancies/top`,
    topInternships: `${API_PREFIX}/vacancies/topinternships`,
  }

  private fetchTop(url: string, region: string, company?: string): Promise<VacancyNewCardModel[]> {
    const params: Record<string, string> = { region: region || 'russia' }
    if (company) {
      params.company = company
    }

    return this.http.request({ url, params }).then(toModels(VacancyNewCardModel))
  }

  getTopVacanciesCompany(slug: string, region: string = 'russia'): Promise<VacancyNewCardModel[]> {
    return this.fetchTop(this.urls.top, region, slug)
  }

  getTopIntershipsCompany(slug: string, region: string = 'russia'): Promise<VacancyNewCardModel[]> {
    return this.fetchTop(this.urls.topInternships, region, slug)
  }
}
